/**
 * User Management Feature - API Layer
 * Pure Supabase and Edge Function calls - NO business logic, NO toasts, NO Sentry
 * All error handling is done at the hook layer
 */

import { supabase } from '@/integrations/supabase/client';

export const userManagementApi = {
  /**
   * Verify current password by attempting sign-in
   */
  async verifyCurrentPassword(email: string, password: string): Promise<boolean> {
    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      throw new Error('Current password is incorrect');
    }

    return true;
  },

  /**
   * Update user password
   */
  async updatePassword(newPassword: string): Promise<void> {
    const { error } = await supabase.auth.updateUser({
      password: newPassword,
    });

    if (error) {
      throw new Error(error.message || 'Failed to update password');
    }
  },

  /**
   * Get current user email
   */
  async getCurrentUserEmail(): Promise<string> {
    const { data: { user } } = await supabase.auth.getUser();

    if (!user?.email) {
      throw new Error('No user session found');
    }

    return user.email;
  },
};
